import React, { useCallback, useEffect } from 'react';
import { ReactComponent  as LeftArrowSvg } from '../../assets/svgs/left_arrow.svg';
import { ReactComponent as  WarnSvg} from '../../assets/svgs/warn.svg';
import { ReactComponent as  CloseSvg} from '../../assets/svgs/close.svg';
import { Cascader, Collapse, DatePicker, Input, message, Select, Spin, Tabs } from 'antd';
import { cn } from '../../utils/utils';
import { useState } from 'react';
import OverviewCom from './components/OverviewCom.jsx';
import ResponseCom from './components/ResponseCom.jsx';
import InsightCom from './components/InsightCom.jsx';
import SvgCom from '../../components/SvgCom/index.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import { getByTopic, getDictionary, getGeographicRegion, getProjectDetail, getProjectResponse,  postCeleryTask, postProInsight, putBatchResponse } from '../../api/request.js';
import AIChatCom from '../../components/AIChatCom/index.jsx';
import { AIChatProvider } from '../../hooks/useAIChat.jsx';
import FilterWinCom from './components/FilterWinCom.jsx';

const collapseClassNames = {
  header: '!text-[13px] !font-semibold !text-primary !p-0 !pt-4',
  body: '!p-0 !pt-2 !pb-5 border-b-2 border-[#00A32E1A] border-solid'
};

const tabItems = [
  {
    key: 'tab_1',
    label: 'Overview',
  },
  {
    key: 'tab_2',
    label: 'Responses',
  },
  {
    key: 'tab_3',
    label: 'AI Insights',
  },
  {
    key: 'tab_4',
    label: 'AI Chat',
  },
];

export const optionsList = [
  // { value: 'category', label: 'Layer I Topic' },
  { value: 'lifeStage', label: 'LifeStage' },
  { value: 'sentiment', label: 'Sentiment' },
  { value: 'dietary', label: 'Dietary' },
  { value: 'age', label: 'Age' },
  { value: 'socialClass', label: 'Social Class' },
  { value: 'geographic', label: 'Geographic' },
];

const ProjectDetailPage = () => {
  const projectId = useParams().projectId;
  const nvigate = useNavigate();
  const [tabIndex, setTabIndex] = useState('tab_1');
  const [detailInfo, setDetailInfo] = useState({});
  const [detailResponse, setDetailResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [isLock, setIsLock] = useState(false);
  const [optionValueList, setOptionValueList] = useState({});
  const [optionValueListForTwo, setOptionValueListForTwo] = useState([]);
  const [filterOne, setFilterOne] = useState('');
  const [filterTwo, setFilterTwo] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [filterThree, setFilterThree] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [filterThemes, setFilterThemes] = useState([]);
  const [customThemes, setCustomThemes] = useState([]);

  const [openAdvance, setOpenAdvance] = useState(false);
  const [advanceObj, setAdvanceObj] = useState({});

  const [curTheme, setCurTheme] = useState(null);

  const items = [
    {
      key: '1',
      label: 'Custom themes',
      classNames: collapseClassNames,
      children: <div>
        <div className="bg-second rounded-lg px-[10px] py-[15px] flex">
          <SvgCom Svg={WarnSvg} size="16"></SvgCom>
          <div className="flex-1 ml-2.5 text-xs font-normal text-primary">
              Create and edit custom themes in theme builder so you can use them here to filter responses like a pro
          </div>
        </div>
        <Input value={curTheme} placeholder='Custom theme' onChange={(event) => {
          const value = event.target.value.trim();
          if(!value) return;
          setCurTheme(value);
        }} onKeyDown={(event) => {
          if (event.key === 'Enter') {
            const tempList = [...customThemes];
            if(!tempList.includes(curTheme)) {
              tempList.push(curTheme);
              setCustomThemes(tempList);
            }
            setCurTheme(null);
          }
        }} className="mt-[10px] rounded-3xl bg-transparent"></Input>
        {
          customThemes.map((item, index) => <div key={index} className={cn('py-[7px] px-[10px] text-xs leading-none font-normal rounded-3xl mt-2 cursor-pointer bg-second text-primary justify-between flex items-center')}>
            <span>{item}</span>
            <SvgCom Svg={CloseSvg} size='10' onClick={() => {
              let tempList = [...customThemes];
              tempList.splice(index, 1);
              setCustomThemes(tempList);
            }}></SvgCom>
          </div>)
        }
      </div>,
    },
    {
      key: '2',
      label: 'Automated themes',
      classNames: collapseClassNames,
      children: <div className="flex flex-wrap">
        {
          // false ? 'bg-second text-primary' :
          (detailResponse?.statistics?.themes || []).map((item, index) => <div key={index} onClick={() => fnChosedTheme(item.theme)} className={cn('py-[7px] px-[10px] text-xs leading-none font-normal rounded-3xl mr-2 mb-2 cursor-pointer',  filterThemes.includes(item.theme) ? 'bg-primary text-white' : 'bg-second text-primary' )}>{item.theme} [{item.count}]</div>)
        }
      </div>,
    },
    {
      key: '3',
      label: 'Additional data',
      classNames: collapseClassNames,
      children: <div className="">
        <div className="text-xs font-normal text-grey-3 mb-1">Variable</div>
        <Select
          allowClear
          style={{ width: 120 }}
          onChange={(value) => setFilterOne(value)}
          placeholder="Please select"
          className='!w-full [&_.ant-select-selector]:rounded-3xl [&_.ant-select-selector]:!bg-transparent'
          options={optionsList}
        />

        <div className="text-xs font-normal text-grey-3 mt-3 mb-1">Value</div>
        {
          filterOne === 'geographic' ?  <Cascader allowClear onChange={(value) => setFilterTwo(value)} className='!w-full [&_.ant-select-selector]:rounded-3xl [&_.ant-select-selector]:!bg-transparent' options={optionValueList[filterOne] || []} placeholder="Please select" />  : 
            <Select
              allowClear
              style={{ width: 120 }}
              onChange={(value) => setFilterTwo(value)}
              placeholder="Please select"
              className='!w-full [&_.ant-select-selector]:rounded-3xl [&_.ant-select-selector]:!bg-transparent'
              options={optionValueList[filterOne] || []}
            />
        }

        {
          (filterTwo && filterTwo !== 'allTopic' && filterOne === 'category') && <>
            <div className="text-xs font-normal text-grey-3 mt-3 mb-1">Layer II Topic Value</div>
            <Select
              allowClear
              style={{ width: 120 }}
              onChange={(value) => setFilterThree(value)}
              placeholder="Please select"
              className='!w-full [&_.ant-select-selector]:rounded-3xl [&_.ant-select-selector]:!bg-transparent'
              options={optionValueListForTwo}
            />
          </>
        }
      </div>,
    },
    {
      key: '4',
      label: 'Date',
      classNames: collapseClassNames,
      children: <div className="">
        <div className="text-xs font-normal text-grey-3 mb-1">Start date</div>
        <DatePicker 
          value={startDate}
          format="YYYY-MM-DD"
          className='!w-full rounded-3xl !bg-transparent'
          placeholder='YYYY-MM-DD'
          onChange={(date) => setStartDate(date)} />

        <div className="text-xs font-normal text-grey-3 mt-3 mb-1">End date</div>
        <DatePicker 
          value={endDate}
          format="YYYY-MM-DD"
          className='!w-full rounded-3xl !bg-transparent'
          placeholder='YYYY-MM-DD'
          onChange={(date) => setEndDate(date)} />
      </div>,
    },
  ];

  const fnChosedTheme = (theme) => {
    const themFilterThemes = [...filterThemes];
    if(themFilterThemes.includes(theme)) {
      themFilterThemes.splice(themFilterThemes.indexOf(theme), 1);
    }
    else {
      themFilterThemes.push(theme);
    }
    setFilterThemes(themFilterThemes);
  };

  /**
   * tab change
   * @param {*} activeKey 
   */
  const onTabChange = (activeKey) => {
    setTabIndex(activeKey);
  };

  /**
   * page go back
   */
  const fnGoBack = () => {
    nvigate(-1);
  };

  const getDetail = useCallback(async() => {
    setLoading(true);
    try {
      const response = await getProjectDetail(projectId);
      const { status = '', message = '', data } = response || {};
      if(status === 'Success') {
        setDetailInfo(data);
      } else {
        throw new Error(message);
      }
    } catch(error) {
      message.error(error?.message || error?.msg || 'service error');
      // nvigate(-1);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  const getDetailForResponse = useCallback(async() => {
    setLoading2(true);
    try {
      setDetailResponse(
        {
          items: [],
        }
      );
      let params = {};
      if(filterThemes.length || customThemes.length) {
        const themes = [...filterThemes, ...customThemes];
        params['themes'] = themes.join(',');
      }
      if(filterOne && filterTwo) {
        if(filterOne === 'geographic') {
          params[filterOne] = filterTwo[filterTwo.length - 1];
        } else {
          params[filterOne] = filterTwo;
        }
      }
      if(startDate || endDate) {
        let tempList = [startDate, endDate];
        tempList = tempList.filter(item => item);
        tempList = tempList.map(item => {
          return item.format('YYYY-MM-DD');
        });
        params['date'] = tempList.join(',');
      }

      const response = await getProjectResponse(projectId, params, advanceObj);
      const { status = '', data } = response || {};
      if(status === 'Success') {
        setDetailResponse(data);
      }
    } catch(error) {
      message.error(error?.message || error?.msg || 'service error');
    } finally {
      setLoading2(false);
    }
  }, [projectId, filterOne, filterTwo, filterThemes, customThemes, startDate, endDate, advanceObj]);

  useEffect(() => {
    getDetailForResponse();
  }, [getDetailForResponse]);

  useEffect(() => {
    getDetail();
  }, [getDetail]);

  const fnPostProInsight = async () => {
    try {
      const result = await postProInsight(projectId);
      if(result.status === 'Success') {
        message.info('Your request has been submitted. Please wait.');
      }
    } catch(error) {
      //
    } finally {
      //
    }
  };

  const  fnPostCeleryTask = async (taskName) => {
    if(isLock) return;
    try {
      setIsLock(true);
      await postCeleryTask(projectId, taskName);
      message.info('Your request has been submitted. Please wait.');
    } catch(error) {
      //
    } finally {
      //
      setTimeout(() => {
        setIsLock(false);
      }, 3000);
    }
  };

  useEffect(() => {
    const fnTest = async() => {
      // getCategory(), 
      const requestList = [getDictionary('lifeStage'), () => {}, getDictionary('dietary'), getDictionary('age'), getDictionary('socialClass'), getGeographicRegion()];

      const responseList = await Promise.all(requestList);
      if(responseList.length > 0) {
        const tempObj = {};
        optionsList.forEach((item, index) => {
          const response = responseList[index];
          const { status, data = [] } = response || {};
          if(status === 'Success') {
            let options = [];
            if(item.value === 'category') {
              options = data.map(item => ({label: item.title, value: item.title}));
              options = [{label: 'allTopic', value: 'All Topic'}, ...options];
            } else if(item.value === 'geographic') {
              options = data.map(item => {
                return {
                  label: item.geographic,
                  value: item.geographic,
                  children: item.countries.map(subItem => ({label: subItem, value: subItem}))
                };
              });
            } else {
              options = data.map(item => ({label: item.value, value: item.value}));
            }
            tempObj[item.value] = options;
          }
        });
        const options = [{label: 'Positive', value: 'Positive'},{label: 'Negative', value: 'Negative'},{label: 'Neutral', value: 'Neutral'}];
        tempObj['sentiment'] = options;

        setOptionValueList(tempObj);
      }
    };

    fnTest();
  }, []);

  useEffect(() => {
    if(filterTwo && filterTwo !== 'allTopic' && filterOne === 'category') {
      const fnRequest = async() => {
        const response = await getByTopic(filterTwo);
        const { status, data = [] } = response || {};
        if(status === 'Success') {
          const options = data.map(item => ({label: item.topic, value: item.topic}));
          setOptionValueListForTwo(options);
        }
      };
      fnRequest();
    }
  }, [filterOne, filterTwo]);

  // download response template
  const fnGetResponseTemplate = async() => {
    try {
      // 创建下载链接
      const link = document.createElement('a');
      link.href = `${process.env.REACT_APP_PYTHON_API_URL}/v1/consumer-processing/project/${projectId}/response/template`;
      link.download = true;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch(error) {
      //
    }
  };

  const fnPutUpdateResponse = async () => {
    try {
      const fileInput = document.getElementById('fileInput');
      fileInput.click();

      const tempUpdate = async () => {
        const file = fileInput.files[0];
        if (file) {
          const formData = new FormData();
          formData.append('file', file);
          try {
            await putBatchResponse(projectId, formData);
            message.success('Update response success');
            getDetailForResponse();
          } catch(error) {
            message.error(error?.message || error?.msg || 'service error');
          } finally {
            fileInput.removeEventListener('change', tempUpdate);
            fileInput.value = '';
          }
        }
      };

      fileInput.addEventListener('change', tempUpdate);
    } catch(error) {
      //
    }
  };
    
  return <AIChatProvider>
    <Spin spinning={loading || loading2} size='large' tip="Loading...">
      <div className="flex justify-start h-full relative">
        {/* Filter Box */}
        <div className="w-[255px] h-[calc(100vh - 90px)] bg-grey-4 px-[15px] py-[20px] rounded-tr-[20px] shadow-filter-box relative z-[1]">
          <div className='flex items-center justify-between'>
            <div className="text-base leading-none font-semibold text-primary">Filter</div>
            <span onClick={() => setOpenAdvance(true)} className='py-[2px] px-2 rounded-[20px] text-primary text-[10px] border-primary border cursor-pointer hover:bg-second'>Advance</span>
          </div>
          {/* <Input className="mt-[10px] rounded-3xl bg-transparent"></Input> */}
          <div className="h-4"></div>
          <div className='overflow-y-auto' style={{height: 'calc(100% - 40px)'}}>
            <Collapse expandIconPosition="end" defaultActiveKey={['1']} ghost items={items}/>
          </div>
        </div>
        {/* top nav bar  */}
        <div className="h-[60px] w-full bg-grey-4 absolute top-0 left-0 pl-[255px]">
          <Tabs defaultActiveKey={tabIndex} onChange={onTabChange} items={tabItems} className="tab-custom [&>div.ant-tabs-nav]:before:border-none [&>div.ant-tabs-nav]:mb-0 ml-[20px] absolute bottom-0" />
        </div>
        {/* Main Box */}
        <div className="flex-1 mt-[60px] px-[20px] pt-[25px] pb-[10px]">
          <div className="text-primary flex justify-between items-center mb-[22px] cursor-pointer">
            <div className='flex items-center justify-start' onClick={fnGoBack}>
              <SvgCom Svg={LeftArrowSvg} size="16"></SvgCom>
              <span className="text-base leading-none font-semibold ml-2">{detailInfo?.title}</span>
            </div>
            <div className='flex items-center justify-start'>
              {
                tabIndex === 'tab_2' && <>
                  <button className="border-btn ml-2" onClick={fnGetResponseTemplate}>
                    <span className="mr-2">Download Template</span>
                  </button>

                  <input type="file" accept='.xlsx' id="fileInput" className="hidden" />
                  <button className="border-btn ml-2" onClick={fnPutUpdateResponse}>
                    <span className="mr-2">Update Response</span>
                  </button>
                </>
              }

              <button className="border-btn ml-2" onClick={() => {getDetail(); getDetailForResponse();}}>
                <span className="mr-2">Refresh Detail</span>
              </button>
              <button className="border-btn ml-2" onClick={fnPostProInsight}>
                <span className="mr-2">Generate Insight</span>
              </button>
              {
                tabIndex === 'tab_1' && <button className="border-btn ml-2" onClick={() => fnPostCeleryTask('analyze_project_responses_sentiment')}>
                  <span className="mr-2">Analyze Project</span>
                </button>
              }

              {
                tabIndex === 'tab_4' && <button className="border-btn ml-2" onClick={() => fnPostCeleryTask('build_consumer_processing_response_vectors')}>
                  <span className="mr-2">Build Vector</span>
                </button>
              }
            </div>
          </div>
          <div className="overflow-y-auto" style={{height: 'calc(100% - 70px)'}}>
            {
              tabIndex === 'tab_1' &&  <>
                {
                  detailResponse?.statistics ? <OverviewCom detailInfo={detailResponse?.statistics}></OverviewCom> : 
                    <div className='flex flex-col items-center justify-center mt-[100px]'>
                      <div className='text-primary text-[14px] mb-5'>The data has not been generated yet. Please analyze it first</div>
                      <button className="border-btn ml-2" onClick={() => fnPostCeleryTask('analyze_project_responses_sentiment')}>
                        <span className="mr-2">Analyze Project</span>
                      </button>
                    </div>
                }
              </>
            }
            {
              tabIndex === 'tab_2' && <ResponseCom optionValueList={optionValueList} onRefreshDetail={getDetailForResponse} responseList={detailResponse.items}></ResponseCom>
            }
            {
              tabIndex === 'tab_3' && <InsightCom insightList={detailInfo?.insights || []} proDesc={detailInfo.key_findings}></InsightCom>
            }
            {
              tabIndex === 'tab_4' &&  <AIChatCom></AIChatCom>
            }
          </div>
        </div>
      </div>
    </Spin>
    <FilterWinCom openWin={openAdvance} onClose={setOpenAdvance} onValueChange={(val) => setAdvanceObj(Object.assign({}, val)) } optionValueList={optionValueList}></FilterWinCom>
  </AIChatProvider>
  ;
};

export default ProjectDetailPage;